import { render, staticRenderFns } from "./good-article.vue?vue&type=template&id=75ae833c&scoped=true&"
import script from "./good-article.vue?vue&type=script&lang=js&"
export * from "./good-article.vue?vue&type=script&lang=js&"
import style0 from "./good-article.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-article.vue?vue&type=style&index=1&id=75ae833c&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ae833c",
  null
  
)

export default component.exports